const {h, render, Component} = require('preact');
const ButtonView = require('../common/button_view')

class ConfirmationPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email_description_box: '',
      email_description_box_isValid: false,
      recaptcha: false,
      email_address_box: '',
      email_address_box_isValid: false,
      user_name_box: '',
      user_name_box_isValid: false
    };

    this.onBackButtonClick = this.onBackButtonClick.bind(this);
    this.onCloseButtonClick = this.onCloseButtonClick.bind(this);
    this.handleClosePopupEvent = this.handleClosePopupEvent.bind(this);
  }

  handleClosePopupEvent() {
    this.props.handleCloseConfirmationPopup()
  }

  onBackButtonClick() {
    this.props.handleBackButtonClick()
  }

  onCloseButtonClick() {
    this.props.handleCloseButtonClick()
  }

  render() {
      return (
          <div class="confirmation-popup">
            <span class="icon-x" onClick={this.handleClosePopupEvent}></span>
            <div class="alert-icon-div">
              <span class="icon-alert"></span>
            </div>
            <div className="close-text">
              {this.props.translationObject.closeText}
            </div>
            <div class="selecting-text">
              {this.props.translationObject.selectingText}
            <br></br><br></br>
                {this.props.translationObject.sureText}
            </div>
            <div class="back-close-buttons">
              <ButtonView onButtonClick={this.onBackButtonClick} inputClass = "back-button"
                          buttonText = {this.props.translationObject.backButtonText}/>
              <ButtonView onButtonClick={this.onCloseButtonClick}  inputClass = "close-button"
                          buttonText = {this.props.translationObject.closeButtonText} />
            </div>
          </div>
      )
    }
}

module.exports = ConfirmationPopup